<template>
  <!-- 
    1.화면ID    : MCF_MN_001
    2.화면명    : 화면메뉴 관리
    3.작성자    : 윤태영 차장
    4.화면설명  : 화면별 메뉴관리 화면 
    * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
    -->
        <div class="content-wrap">
          <!-- 영업기회ID -->
          <div class="row gx-3">
            <div class="col-md-4 col-sm-12">
              <div class="border h-100">
                <div class="code-subtitle">메뉴관리</div>
                <div class="py-3 px-5 dotline-b">
                  <ElButton type="codeRegist" @buttonClick="clickRowCRUD('add')"><span class="ic-code-plus"></span> 등록</ElButton>
                  <ElButton type="codeRegist" @buttonClick="clickRowCRUD('addChild')"><span class="ic-code-plus"></span> 하위등록</ElButton>
                  <ElButton type="codeRegist" @buttonClick="clickRowCRUD('edit')"><span class="ic-code-edit"></span> 수정</ElButton>
                  <!-- <ElButton type="codeRegist" @buttonClick="clickRowCRUD('delete')"><span class="ic-code-del"></span> 삭제</ElButton> -->
                </div>
                <!--메뉴관리 공통컴포넌트-->
                <Tree ref="treeRef" 
                      :menuList="state.treeData" 
                      :context-menu="true" 
                      :parent-id="'upper_menu_id'"
                      :id="'menu_id'" 
                      :id-nm="'menu_nm'" 
                      :root-val="''" 
                      @return="r => getMenuData(r)" 
                      @addRow="r => addRow(r)"
                      @updateRow="r => updateRow(r)" 
                      @deleteRow="r => deleteRow(r)" 
                      @contextmenu.prevent 
                  />
        </div>
      </div>
      <div class="col-md-8 col-sm-12">
        <div class="border h-100">
          <div class="code-subtitle">상세정보</div>
          <div class="p-3">
            <div class="table-responsive">
              <!-- <div class="row">
                <div class="col-md-12">
                  <div class="mb-3"> -->
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th class="text-bg-light align-middle">메뉴ID</th>
                          <td>
                            <ElInput :id="id" v-model="state.privilegeParams.menu_id" readonly/>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-bg-light align-middle">메뉴명</th>
                          <td>
                            <ElInput :id="id" v-model="state.privilegeParams.menu_nm" />
                          </td>
                        </tr>
                        <tr>
                          <th class="text-bg-light align-middle">설명</th>
                          <td>
                            <ElInput :id="id" v-model="state.privilegeParams.descrpt" />
                          </td>
                        </tr>
                        <tr>
                          <th class="text-bg-light align-middle">메뉴순서</th>
                          <td>
                          <ElInput :id="id" v-model="state.privilegeParams.menu_sort" :onlyNumber="true" :maxlength="3"/>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-bg-light align-middle">상위메뉴ID</th>
                          <td>
                            <ElInput :id="id" v-model="state.privilegeParams.upper_menu_id" readonly/>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-bg-light align-middle">화면ID</th>
                          <td>
                            <ElInput :id="id" v-model="state.privilegeParams.scren_id" readonly/>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-bg-light align-middle">메뉴URL</th>
                          <td>
                            <ElInput :id="id" v-model="state.privilegeParams.menu_url" />
                          </td>
                        </tr>
                        <tr>
                          <th class="text-bg-light align-middle">사용여부</th>
                          <td>
                            <select v-model="state.privilegeParams.enable_yn" class="form-select"
                              aria-label="Default select example">
                              <option v-for="(item, index) in state.enable_yn" :key="index" :value="item.value">{{
                                item.text }}</option>
                            </select>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  <!-- </div>The end of mb-3 class property in div tag  -->
                <!-- </div>
              </div> -->
            </div>

            <div class="text-end py-3">
              <ElButton type="primary" @buttonClick="editRow()">저장</ElButton>
              <!-- <ElButton type="primary" @buttonClick="deleteRow()">삭제</ElButton> -->
            </div> 

          </div>
        </div>

               
      </div>
    </div>
  </div>
</template>

<script setup>

import { reactive, ref, onBeforeMount } from 'vue'
import api from '@/utils/api'
import Tree from '@/components/common/SettingTree.vue';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { menuList, menuEdit, menuDelete, menuTreeEdit } from '@/api/menu';
import common from '@/js/common';

const treeRef = ref();

onBeforeMount(async () => {
  await getMenuList();
})

//화면메뉴 리스트 조회
const getMenuList = async () => {
  try {
    setIsLoading(true)
    const res = await menuList()
    state.treeData = [...res.rtn]
  } catch (err) {
    console.error(err)
    alert('화면메뉴를 불러오는데 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}

//변수 선언 영역 
const state = reactive({
  enable_yn: [{ text: 'N', value: 'N' }, { text: 'Y', value: 'Y' }],
  privilegeParams: {
    menu_id: '',
    menu_nm: '',
    descrpt: '',
    menu_sort: '',
    upper_menu_id: '',
    scren_idx: '',
    scren_id: '',
    menu_url: '',
    enable_yn: 'N',
    del_yn: '',
  },

});

//수정
const editRow = async () => {

  let params = {
    menu_id: state.privilegeParams.menu_id,
    menu_nm: state.privilegeParams.menu_nm,
    descrpt: state.privilegeParams.descrpt,
    menu_sort: Number(state.privilegeParams.menu_sort) ,
    upper_menu_id: state.privilegeParams.upper_menu_id,   // 상위메뉴 ID 
    scren_id: state.privilegeParams.scren_id,     //화면ID 
    menu_url: state.privilegeParams.menu_url,
    enable_yn: state.privilegeParams.enable_yn,

    upd_id: userStore.user.employeeId,
  }
  if (params.menu_id.length > 0) {
    if (confirm("수정 하시겠습니까?") == true) {
      try {
        setIsLoading(true)
        const res = await menuEdit(params)
        alert('수정완료 하였습니다.');
        getMenuList();
        getDataList();
      } catch (err) {
        console.error(err)
        alert('메뉴속성 상세정보 등록&수정 에러 ');
      } finally {
        setIsLoading(false)
      }
    }
  } else {
    alert('해당 메뉴를 선택하여 주세요');  // 수정 Validation 알림 
  }

};


//삭제 함수
const deleteRow = async () => {

  let params = {
    scren_id: state.privilegeParams.scren_id,     //화면ID 
    menu_id: state.privilegeParams.menu_id,      //메뉴ID 
    upd_id: userStore.user.employeeId,
  }

  if (params.menu_id.length > 0) {
    if (confirm("삭제 하시겠습니까?") == true) {
      try {
        setIsLoading(true)
        const res = await menuDelete(params)
        alert('삭제 되었습니다.');
        state.privilegeParams = {
          menu_id: '',
          menu_nm: '',
          descrpt: '',
          menu_sort: '',
          upper_menu_id: '',
          scren_idx: '',
          scren_id: '',
          menu_url: '',
          enable_yn: '',
          del_yn: '',
        }

        getMenuList();
      } catch (err) {
        console.error(err)
      } finally {
        setIsLoading(false)
      }
    } // The end of if statement block    
  } else {
    alert('해당 메뉴를 선택하여 주세요');
  }
};

//조회
const getDataList = async () => {

  let params = {
    scren_id: state.privilegeParams.scren_id,
    menu_id: state.privilegeParams.menu_id,
  }

  try {
    setIsLoading(true)
    const res = await menuList(params)
    if (!res.rtn.length) {
      alert('결과값이 없습니다.')
      return
    }

    //단건 처리 
    let rtnValMenuId = res.rtn[0].menu_id;
    let rtnValMenuNm = res.rtn[0].menu_nm;
    let rtnValDescrpt = res.rtn[0].descrpt;
    let rtnValUpperMenuId = res.rtn[0].upper_menu_id;  //상위메뉴 ID 
    let rtnValUpperMenuSort = res.rtn[0].menu_sort;      //메뉴순서
    let rtnValScrenId = res.rtn[0].scren_id;       //화면ID 
    let rtnValEnableYn = res.rtn[0].enable_yn;      //사용여부 
    let rtnValMenuUrl = res.rtn[0].menu_url;
    let rtnValDelYn = res.rtn[0].del_yn;         //삭제여부 

    state.privilegeParams.menu_id = rtnValMenuId;
    state.privilegeParams.menu_nm = rtnValMenuNm;
    state.privilegeParams.descrpt = rtnValDescrpt
    state.privilegeParams.upper_menu_id = rtnValUpperMenuId;
    state.privilegeParams.menu_sort = rtnValUpperMenuSort;
    state.privilegeParams.scren_id = rtnValScrenId;
    state.privilegeParams.enable_yn = rtnValEnableYn;
    state.privilegeParams.menu_url = rtnValMenuUrl;
    state.privilegeParams.del_yn = rtnValDelYn;

  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
};

//상세정보 조회 (요구사항 변경으로 불필요 차후 삭제 예정
const getDataSubList = async (menu) => {


  let params = {
    scren_id: menu.scren_id,
  }
  try {
    setIsLoading(true)
    const res = await menuList(params)
    if (!res.rtn.length) {
      alert('결과값이 없습니다.')
      return
    }

    //Single-Variable data on each variable
    let rtnValMenuId = res.rtn[0].menu_id;
    let rtnValMenuNm = res.rtn[0].menu_nm;
    let rtnValMenuDesc = res.rtn[0].menu_desc;
    let rtnValUpperMenuId = res.rtn[0].upper_menu_id;  //상위메뉴 ID 
    let rtnValUpperMenuSort = res.rtn[0].menu_sort;//메뉴순서
    let rtnValScrenId = res.rtn[0].scren_id;//화면ID 
    let rtnValEnableYn = res.rtn[0].enable_yn;//사용여부 



    state.privilegeParams.menu_id = rtnValMenuId;
    state.privilegeParams.menu_nm = rtnValMenuNm;
    state.privilegeParams.menu_desc = rtnValMenuDesc;
    state.privilegeParams.upper_menu_id = rtnValUpperMenuId;
    state.privilegeParams.menu_sort = rtnValUpperMenuSort;
    state.privilegeParams.scren_id = rtnValScrenId;
    state.privilegeParams.enable_yn = rtnValEnableYn;

  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
};

const getMenuData = (menu) => {
  state.privilegeParams.menu_id = menu.menu_id ? menu.menu_id : ''
  state.privilegeParams.menu_nm = menu.menu_nm ? menu.menu_nm : ''
  state.privilegeParams.descrpt = menu.descrpt ? menu.descrpt : ''
  state.privilegeParams.menu_sort = menu.menu_sort ? menu.menu_sort : ''
  state.privilegeParams.upper_menu_id = menu.upper_menu_id ? menu.upper_menu_id : ''
  state.privilegeParams.scren_id = menu.scren_id ? menu.scren_id : ''
  state.privilegeParams.menu_url = menu.menu_url ? menu.menu_url : ''
  state.privilegeParams.enable_yn = menu.enable_yn ? menu.enable_yn : ''
  state.privilegeParams.del_yn = menu.del_yn ? menu.del_yn : ''
  /////getDataSubList(menu); // 상세정보 

}

const clickRowCRUD = (status) => {
  treeRef.value.clickRowCRUD(status)
}

const addRow = async (row) => {
  row['enable_yn'] = 'Y'

  await fetchMenuEdit(row)
}

const fetchMenuEdit = async (params) => {
  //case 1 context menu통한 업뎃 및 추가
  try {
    setIsLoading(true)
    const res = await menuTreeEdit(params)
    getMenuList();
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}




const updateRow = async (row) => {
  let params = {
    menu_id: row.menu_id,
    menu_nm: row.menu_nm,
    descrpt: row.descrpt,
    menu_sort: Number(row.menu_sort) ,
    upper_menu_id: row.upper_menu_id,   // 상위메뉴 ID 
    scren_id: row.scren_id,     //화면ID 
    menu_url: row.menu_url,
    enable_yn: row.enable_yn,

    upd_id: userStore.user.employeeId,
  }
  if (params.menu_id.length > 0) {
    
    try {
      setIsLoading(true)
      await menuEdit(params)
      getMenuList();
      getDataList();
    } catch (err) {
      console.error(err)
      alert('메뉴속성 상세정보 등록&수정 에러 ');
    } finally {
      setIsLoading(false)
    }
    
  } else {
    alert('해당 메뉴를 선택하여 주세요');  // 수정 Validation 알림 
  }

}


</script>